import { Global } from '@emotion/core';
import React, { createContext, ReactNode, useContext } from 'react';
import { V4Styles } from './GlobalCss/V4Styles';
import { V5Styles } from './GlobalCss/V5Styles';

type ThemeContextType = {
  isRebrand: boolean;
};

const ThemeContext = createContext<ThemeContextType>({
  isRebrand: false,
});

export const useTheme = () => {
  const isRebrand = useContext(ThemeContext);
  return isRebrand;
};

// 🍪 value for the rebrand
export const REBRAND_COOKIE = '__tnp';

export const GlobalStylesProvider = ({
  children,
  isRebrand,
}: {
  children: ReactNode;
  isRebrand: boolean;
}) => {
  return (
    <ThemeContext.Provider value={{ isRebrand }}>
      <Global styles={isRebrand ? V5Styles : V4Styles} />
      {children}
    </ThemeContext.Provider>
  );
};
